'use client'

import MsgRow from '@comp/page/common/chat/msg-row'
import SendBar from '@comp/page/common/chat/send-bar'
import { useSysMsg } from '@comp/sys-msg'
import clsx from 'clsx'
import { get, map } from 'lodash-es'
import { useEffect } from 'react'
import { useUnmount } from 'react-use'

export default function Chat({ data, show = false }) {
  const { wsRef, chatMessages } = useSysMsg()
  useEffect(() => {
    if (show) {
      wsRef.current.joinRoom(get(data, 'liveStream.chatRoomId'))
    }
  }, [wsRef, data, show])

  useUnmount(() => {
    wsRef.current.leaveRoom()
  })

  return (
    <div className={clsx('flex h-pix-440 flex-col', { hidden: !show })}>
      <div className="min-h-0 flex-1 overflow-auto bg-white p-pix-10 flex flex-col gap-y-pix-10 sm:p-pix-20 sm:gap-y-pix-20">
        {map(chatMessages, (item, idx) => (
          <MsgRow data={item} key={idx} />
        ))}
      </div>
      <SendBar />
    </div>
  )
}
